import script from "./UpcomingCoach.vue?vue&type=script&setup=true&lang=js"
export * from "./UpcomingCoach.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__